import React, { useState, useEffect, useRef, createRef } from "react";
import { useForm } from "react-hook-form";
import { Document, Page, pdfjs } from "react-pdf";
import { yupResolver } from "@hookform/resolvers/yup";
import {
    FormBuilder,
} from "../../utils/FormBuilder/FormBuilder";
import { generateValidationSchema } from "../../utils/FormBuilder/Validators";
import { Button } from "@mui/material";
import { FormField } from "../../interfaces/User.interface";
import { url } from "inspector";
import { sign } from "crypto";
import { useNavigate } from "react-router-dom";
import { useLoading } from "../../contexts/LoadingContext";
import { useFetch } from "../../utils/FetchTemplate";
import { useAuth } from "../../contexts/AuthContext";

pdfjs.GlobalWorkerOptions.workerSrc = new URL(
    "pdfjs-dist/build/pdf.worker.min.js",
    import.meta.url
).toString();
export interface DraggableImageProps {
    imageUrl: string;
    canvasRef?: HTMLCanvasElement;
    initialPosition: { x: number; y: number };
}

export const ContractViewer: React.FC<{ url: string }> = ({ url }) => {
    const [numPages, setNumPages] = useState<number | null>(null);
    const componentRef = useRef<HTMLDivElement>(null);
    const pageRefs = useRef<HTMLCanvasElement[]>([]);

    async function onDocumentLoadSuccess({ numPages }: { numPages: number }) {
        setNumPages(numPages);
    }

    return (
        <div
            className="flex justify-center items-center w-full"
            ref={componentRef}
        >
            <Document
                className="w-full h-screen overflow-y-scroll"
                file={url}
                onLoadSuccess={onDocumentLoadSuccess}
            >
                {Array.from(new Array(numPages), (el, index) => (
                    <Page
                        className={`border-2 border-black`}
                        key={`page_${index + 1}`}
                        pageNumber={index + 1}
                        renderTextLayer={false}
                        renderAnnotationLayer={false}
                        // onLoadSuccess={onPageLoadSuccess}
                        width={componentRef.current?.offsetWidth}
                        canvasRef={(x) =>
                            (pageRefs.current[index] = x as HTMLCanvasElement)
                        }
                    >
                        {/* <ContractPage canvasRef={pageRefs.current[index]} imageProps={imageProps} index={index}></ContractPage> */}
                    </Page>
                ))}
            </Document>
        </div>
    );
};

export const Step2ContractViewer: React.FC<{
    handleNext: () => void;
    url: string;
    prevData: Object;
}> = ({ handleNext, url, prevData }) => {
    const formFields: FormField[] = [
        {
            name: "signature",
            question: "Please leave your signature below:",
            validation: "text",
            required: true,
            questionType: "sign",
        },
    ];
    const navigate = useNavigate();
    const validationSchema = generateValidationSchema(formFields);
    const { postData, getData } = useFetch()

    const {
        handleSubmit,
        control,
        watch,
        formState: { errors },
        reset,
    } = useForm({
        resolver: yupResolver(validationSchema),
    });

    const formValues = watch();


    const onSubmit = async (data: any) => {
        // TODO: POST THE DATA TO SERVER
        const formData = {
            ...prevData,
            ...data
        }
        const url = process.env.REACT_APP_BACKEND_URL + `/api/member/create/withPayment/stage2`;
        postData(url, formData).then((responseData) => {
            const paymentUrl = responseData.paymentUrl;
            window.location.href = paymentUrl
        }).catch().finally(() => {
            reset(); // Clear the form after submission
        });
    };

    return (
        <div className="space-y-6">
            <ContractViewer url={url}></ContractViewer>
            <form onSubmit={handleSubmit(onSubmit)} id="form" encType="multipart/form-data">
                {FormBuilder(formFields, control, errors)}
                <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    form="form"
                >
                    Submit
                </Button>
            </form>
        </div>
    );
};
